import React from 'react';
import { cn } from '@/lib/utils';
import { REACTION_TYPES } from './ReactionPicker';

interface ReactionDisplayProps {
  reactionsCount: Record<string, number>;
  userReactions: string[];
  onReactionClick: (reactionType: string) => void;
}

const ReactionDisplay: React.FC<ReactionDisplayProps> = ({
  reactionsCount,
  userReactions,
  onReactionClick,
}) => {
  // Filter to only show reactions with count > 0
  const activeReactions = Object.entries(reactionsCount)
    .filter(([_, count]) => count > 0)
    .sort((a, b) => b[1] - a[1]); // Sort by count descending

  if (activeReactions.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-1 mt-2">
      {activeReactions.map(([type, count]) => {
        const reaction = REACTION_TYPES.find(r => r.id === type);
        if (!reaction) return null;
        
        const isUserReaction = userReactions.includes(type);
        
        return (
          <button
            key={type}
            onClick={() => onReactionClick(type)}
            className={cn(
              'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-sm transition-all',
              'border hover:scale-105',
              isUserReaction
                ? 'bg-primary/10 border-primary text-primary'
                : 'bg-muted border-border text-muted-foreground hover:bg-accent'
            )}
            title={`${reaction.label} - ${count}`}
          >
            <span className="text-base">{reaction.emoji}</span>
            <span className="font-medium">{count}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ReactionDisplay;
